export const enum pageStates {
  securityQuestions = "securityQuestions",
  twoFactorAuthPart1 = "twoFactorAuthPart1",
  twoFactorAuthPart2 = "twoFactorAuthPart2",
  twoFactorAuthPart3 = "twoFactorAuthPart3",
  languagePreference = "languagePreference",
}
